module.exports = __webpack_public_path__ + "images/gfr-coins.webp";